
import { accountProductGetters, accountCategoryGetters, accountSellpointGetters, accountUserGetters } from './getters'
import { accountProductMutations, accountCategoryMutations, accountSellpointMutations, accountUserMutations} from './mutations'
import { accountProductActions, accountCategoryActions, accountSellpointActions, accountUserActions} from './actions'

export const account = {
    namespaced: true,

    // module assets
    state: () => ({
        store_user:{}, 
        store_sellpoints: {}, //all user sellpoint
        store_sellpoint: {}, //active sellpoint
        store_orders:{},
        store_stores:{}, //user saved/favorite stores
        store_posts:{},
        store_post:{},
    }), // module state is already nested and not affected by namespace option

    // getters: {
    //     userLogin () { 

    //     } // -> getters['account/userLogin']
    // },
    // actions: {
    //     userLogin () { 

    //      } // -> dispatch('account/userLogin')
    // },
    // mutations: {
    //     userLogin () { 

    //      } // -> commit('account/userLogin')
    // },

    getters: Object.assign({}, accountUserGetters, accountProductGetters, accountCategoryGetters, accountSellpointGetters),
    mutations: Object.assign({}, accountUserMutations, accountProductMutations, accountCategoryMutations, accountSellpointMutations),
    actions: Object.assign({}, accountUserActions, accountProductActions, accountCategoryActions, accountSellpointActions),

    // nested modules
    /*modules: {
        // inherits the namespace from parent module
        store_sellpoint: {
            state: () => ({ 
                store_sellpoint: {},
                store_categories:{},
                store_category:{},
                store_category_products:{},
                store_products: {},
                store_product: {},
                store_orders:{},
                store_posts:{},
                store_post:{},
                //
                store_sellpointAppSubscriptionOffers:{},
                store_sellpointShipping:{},
                store_sellpointDiscounts:{},
            }),
            // getters: {
            //     sellpoint () { 

            //     } // -> getters['account/profile']
            // },
            // actions: {
            //     setSellpoint () { 
    
            //      } // -> dispatch('account/login')
            // },
            // mutations: {
            //     setSellpoint () { 
    
            //     } // -> commit('account/login')
            // },
            getters: Object.assign({}, accountProductGetters, accountCategoryGetters, accountSellpointGetters),
            mutations: Object.assign({}, accountProductMutations, accountCategoryMutations, accountSellpointMutations),
            actions: Object.assign({}, accountProductActions, accountCategoryActions, accountSellpointActions)
        },
    }*/
}


// WEBPACK FOOTER //
// ./src/store/modules/account/index.js